document.addEventListener('DOMContentLoaded', () => {
  function wpThumb(url, size = '108x108') {
    if (!url) return null;
    return url.replace(/(\.[a-zA-Z0-9]+)$/, `-${size}$1`);
  }

  let restUrl = window.wpApiSettings?.root || '/wp-json/';

  // Fix: If API is on the same hostname, use relative path to avoid CORS/Mixed Content issues 
  // (e.g. if site is http:// but API settings say https://)
  try {
    const url = new URL(restUrl);
    if (url.hostname === window.location.hostname) {
      restUrl = url.pathname;
    }
  } catch (e) {
    console.warn('Invalid API root URL, falling back to relative path');
    restUrl = '/wp-json/';
  }

  const nonce = window.wpApiSettings?.nonce || '';

  // Set up each search widget independently
  document.querySelectorAll('.venue-search-container').forEach(container => {
    const icon = container.querySelector('.search-venues');
    const inputWrapper = container.querySelector('.venue-search-input-wrapper') || container.querySelector('div');
    const input = container.querySelector('.venue-quick-search') || container.querySelector('input.form-control');
    const results = container.querySelector('.venue-search-results') || container.querySelector('ul.list-group');

    if (!input || !results || !icon) return; // defensively skip if structure is incomplete

    let currentRequestController = null;

    // --- Helpers
    const showResults = () => { results.style.display = 'flex'; };
    const hideResults = () => { results.style.display = 'none'; };
    const clearResults = () => { results.innerHTML = ''; };

    const collapse = () => {
      inputWrapper.classList.remove('expanded');
      inputWrapper.classList.add('collapsed');
      input.value = '';
      hideResults();
    };

    const expand = () => {
      inputWrapper.classList.remove('collapsed');
      inputWrapper.classList.add('expanded');
      input.focus();
    };

    // --- Search as you type (with in-flight abort)
    input.addEventListener('input', () => {
      const query = input.value.trim();

      if (query.length < 2) {
        hideResults();
        clearResults();
        return;
      }

      // Abort previous request if any
      if (currentRequestController) currentRequestController.abort();
      currentRequestController = new AbortController();

      fetch(`${restUrl}wp/v2/weddingvenues?search=${encodeURIComponent(query)}&per_page=5&_embed=`, {
        method: 'GET',
        headers: { 'X-WP-Nonce': nonce },
        signal: currentRequestController.signal,
      })
        .then(res => {
          if (!res.ok) throw new Error('Network response was not ok');
          return res.json();
        })
        .then(data => {
          console.log("API RESPONSE ITEM:", JSON.stringify(data[0], null, 2));
          if (!Array.isArray(data) || data.length === 0) {
            results.innerHTML = `<li class="list-group-item border-0 p-2 disabled">No results found</li>`;
            showResults();
            return;
          }

          // Build items (ensure attributes aren’t malformed)
          results.innerHTML = data.map(post => {
            const title = (post?.title?.rendered ?? '').toString();
            const link = (post?.link ?? '#').toString();
            // The API now processes the image to return the most appropriate thumbnail URL
            const img = post?.listing_image || 'fallback-image.jpg';
            const averageRating = (post?.average_rating ?? '0.0').toString();
            const totalReviews = (post?.total_reviews ?? '0').toString();
            const location = Array.isArray(post?.location) && post.location.length
              ? post.location[0].name
              : 'Unknown';

            return `
              <li class="list-group-item list-group-item-action border-0 p-0 d-flex align-items-center gap-3" data-url="${link}">
                <img src="${img}" alt="${title}" style="width:108px; height:108px; object-fit:cover; border-radius:4px;">
                <div class="flex-grow-1">
                  <div class="fw-semibold">${title}</div>
                  <div class="text-muted small">
                    <div><i class="fa fa-star text-saffron me-1"></i>${totalReviews}</div>
                    <div class="subheading">${location}</div>
                  </div>
                </div>
              </li>
            `;
          }).join('');

          showResults();
        })
        .catch(() => {
          results.innerHTML = `<li class="list-group-item border-0 p-2 disabled"><img src="/wp-content/themes/uk/img/navbar/search-loading.png" alt="Loading..." style="max-width: 402px; opacity: 0.5;height:auto;display:block;margin:auto;" /></li>`;
          showResults();
        });
    });

    // Click on a result (use closest to catch child clicks)
    results.addEventListener('click', e => {
      const li = e.target.closest('li[data-url]');
      if (li) {
        window.location.href = li.dataset.url;
      }
    });

    // Toggle via icon
    icon.addEventListener('click', () => {
      const isCollapsed = inputWrapper.classList.contains('collapsed');
      if (isCollapsed) {
        expand();
      } else {
        collapse();
      }
    });

    // Close when clicking outside THIS container (doesn’t affect other instances)
    document.addEventListener('click', e => {
      if (!container.contains(e.target)) {
        collapse();
      }
    });
  });
});